"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setColorAlphaChannel = exports.getRandomHexColor = exports.getLighterColor = exports.getExtendedColors = exports.getDarkerColor = void 0;
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getLighterColor = exports.getLighterColor = function getLighterColor(fullColor) {
  var perc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;
  return (0, _color["default"])(fullColor).fade(perc).string();
};
var getDarkerColor = exports.getDarkerColor = function getDarkerColor(fullColor) {
  var perc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;
  return (0, _color["default"])(fullColor).darken(perc).hex();
};
var setColorAlphaChannel = exports.setColorAlphaChannel = function setColorAlphaChannel(fullColor) {
  var perc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.9;
  return (0, _color["default"])(fullColor).alpha(perc).string();
};
var getRandomHexColor = exports.getRandomHexColor = function getRandomHexColor() {
  return "#".concat(Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0'));
};
var getExtendedColors = exports.getExtendedColors = function getExtendedColors(max, themeColors) {
  if (max < themeColors.length) {
    return themeColors;
  }
  return [].concat(_toConsumableArray(themeColors), _toConsumableArray(Array.from(Array(max - themeColors.length + 1)).map(function () {
    return getRandomHexColor();
  })));
};